<template>
  <div v-if="existTask">
    <!-- 首页-->
    <template v-if="!isEmbed && componentType == 'home'">
      <div class="navbar-itme">
        <router-link
          class="f messages el-badge"
          to=""
          style="background-color: rgb(217, 229, 253);color: black;"
        >
          <div id="showExportBtn" @click="shrink">
            <i class="el-icon-download"></i>
            下载列表
            <sup
              v-show="existTask"
              class="el-badge__content el-badge__content&#45;&#45;undefined is-fixed"
              style="top: 17px"
              >{{ tasks ? tasks.length : 0 }}</sup
            >
          </div>
        </router-link>
      </div>
    </template>

    <!-- 监管端-->
    <router-link
      v-if="!isEmbed && componentType == 'supervise'"
      class="f messages el-badge"
      to=""
      style="width: 100px;"
    >
      <div id="showExportBtn" @click="shrink">
        <i class="el-icon-download"></i>
        下载列表
        <sup
          v-show="existTask"
          class="el-badge__content el-badge__content&#45;&#45;undefined is-fixed"
          style="top: 17px"
          >{{ tasks ? tasks.length : 0 }}</sup
        >
      </div>
    </router-link>

    <el-popover
      v-draw
      placement="right-start"
      width="300"
      trigger="manual"
      id="exportFilePopover"
      style="margin-top: 15px"
      v-model="popoverShow"
    >
      <el-row style="padding-top: 10px; font-weight: bold; " v-if="!isEmbed">
        <el-col :span="12" style="color: #909399">
          <i class="el-icon-download"></i>
          文件下载列表
        </el-col>
        <el-col :span="12" style="text-align: right" v-if="existTask">
          <el-popconfirm title="确定清空全部任务吗？" @onConfirm="closeAll()">
            <el-button slot="reference" type="text" style="padding: 0px"
              >清空全部</el-button
            >
          </el-popconfirm>
        </el-col>
        <el-divider style="margin: 0px !important;"></el-divider>
      </el-row>

      <el-row v-else>
        <div class="df" style="height: 35px;padding: 10px; margin-bottom: 10px">
          <!-- 下载图标  -->
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAACMUlEQVQ4T53Vy6tXVRjG8c/xipKoM00zL0cQnXmdOIoKnYWoZA0UFEUdKCrO/AO8kQMvJSQiSFF5QWgQSIUOJFNwoAPxehRFc2Jk6vHOI2vDPtutB9ywYf/e9a7vWut53/X8OrQ/AzEfX2A6PsRL3MZpHMFhPG1O72jhfYltGFUbe4y+6F+L3cQG/FRn1IF9sBMrS8JJfIvfcafEssgnWI7ZJZac1XiR33Xg7gL7Dyvww1vkqMKL8B2GYA9W1YE5ZgAP8Cn+asCGFw3vN+KzcBwfYCF+zg4H4QpGYjEONCalQNHwXwxr2XXm7McNTAywCqR6WbH59AZM/hlMCyvAQ5iHZfj+PYHRb1daKcDr+Bjjca0G7IdnaNthNValT8F5dAXYXforSa9Lj078Wqp9qqFhxN+EObhV8lOUdMeTACP4ANSBo/FHKVTk+K0UZUlp5IulH+8V4FCkA7oDvIpxmFC+q2N8hD8xAoPL8Z/jcoH9U5NnKs5GsgBzdRa8pSjRNtCxZfKFFliGNmJz1Ydf4SD+xsyWKgcW6P8FdreRkzuegkzC19lh9LuEMViKfS3QSPIQTVhS1+IbxCw6q7scm4odPcJcnOjlHlfDn+NYaa3I9kvdHLZjXWmjNdhb7m8bO8dMM28tsBhLHKeH2wS+BetL/FyBpn26Six6flbsa3JZKZaXDbxhX9VOcvwd5fa86+Rp6hjsj/WkNsfOeJw5DZ13Rs298xcQIzgavYo8PRZ9BdeNf98zL551AAAAAElFTkSuQmCC"
            alt=""
            class="el-notification__icon el-notification__icon_custom"
          />
          <h2 style="margin-left: 8px" class="el-notification__title el-badge">
            下载列表
            <sup
              class="el-badge__content el-badge__content&#45;&#45;undefined is-fixed"
              style="top: 2px"
              v-if="taskDivHide"
              >{{ tasks ? tasks.length : 0 }}</sup
            >
          </h2>
          <div>
            <template v-if="taskDivHide">
              <div
                title="展开"
                class=" hiddenBtn el-icon-caret-top"
                @click="taskDivHide = false"
              ></div>
            </template>
            <template v-else>
              <div
                title="关闭"
                class=" hiddenBtn el-icon-caret-bottom"
                @click="taskDivHide = true"
              ></div>
            </template>
            <el-popconfirm title="确定清空全部任务吗？" @onConfirm="closeAll()">
              <div
                slot="reference"
                class="nodrag el-notification__closeBtn el-icon-close position_custom"
              ></div>
            </el-popconfirm>
          </div>
        </div>
      </el-row>

      <template v-if="!popoverTaskHide">
        <div id="tasksDiv" v-if="existTask">
          <p class="df" style="margin-bottom: 10px;" v-for="row in this.tasks">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAASUlEQVQYV3XNwQmAMBAEwMnHtxVqB/rSInwZS7DBWIIcGpCA+znY4diEDhsGT06sCTvmt6wnBxT0DVx/UAIypubjCKjj42d8uQErigsRrcHQ3gAAAABJRU5ErkJggg=="
              class="list_round"
            />
            <span>
              <span
                class="flexdc"
                style="font-size: 14px; line-height: 14px; margin-bottom: 6px;"
                v-html="row.fileName"
                >2021_企业培训档案</span
              >
              <span>
                <template
                  v-if="
                    row.taskState == exportFileConstant.taskStatus.processing
                  "
                >
                  <!--处理成功-->
                  <span style="color: #e6a23c;">处理中</span>
                </template>
                <template
                  v-if="row.taskState == exportFileConstant.taskStatus.sucess"
                >
                  <!--处理成功-->
                  <span class="success_color">已完成</span>
                  <!--处理失败-->
                  <span class="load_fail_btn">
                    <a
                      :href="row.downloadURL"
                      class="nodrag el-link el-link--primary is-underline"
                      style="margin-left: 10px;"
                      ><span class="el-link--inner">下载</span></a
                    >
                  </span>
                </template>
                <template
                  v-if="row.taskState == exportFileConstant.taskStatus.failure"
                >
                  <!--处理成功-->
                  <span style="color: #f56c6c">失败</span>
                  <!--处理失败-->
                  <span class="load_fail_btn">
                    <el-popover
                      placement="top-start"
                      width="200"
                      trigger="hover"
                    >
                      <span style="color: #F56C6C"> {{ row.errorMsg }}</span>
                      <el-link slot="reference" type="danger" :underline="false"
                        >失败描述</el-link
                      >
                    </el-popover>
                  </span>
                </template>
              </span>
            </span>
          </p>
        </div>
        <emptyContainer v-if="!existTask"></emptyContainer>
      </template>
    </el-popover>
  </div>
</template>

<script>
import exportApi from "@/api/training/api_export";
import $exportFileConstant from "@/pages/trainingManagement/component/exportFile/exportFileConstant";
import { bus } from "../../../../bus";
import emptyContainer from "@/components/emptyContainer";

export default {
  name: "exportFile",
  components: { emptyContainer },
  props: {
    componentType: {
      type: String,
      default: () => {
        return "home";
      }
    }
  },
  data() {
    return {
      tasks: [], // 任务列表
      id: 1,
      isHidden: false,
      refreshAsyncTasksStatusInterval: undefined,
      exportFileConstant: $exportFileConstant,
      isEmbed: false,
      taskDivHide: false
    };
  },
  //自定义指令
  directives: {
    drag(el) {
      el.onmousedown = function(e) {
        var disx = e.pageX - el.offsetLeft;
        var disy = e.pageY - el.offsetTop;
        document.onmousemove = function(e) {
          el.style.left = e.pageX - disx + "px";
          el.style.top = e.pageY - disy + "px";
        };
        document.onmouseup = function() {
          document.onmousemove = document.onmouseup = null;
        };
      };
    }
  },
  methods: {
    /**
     * put 一个任务  （组件提供的api ）
     */
    putAsyncTask(param) {
      this.asyncTaskRequest([param]);
    },
    /**
     * put 一组任务
     */
    putAsyncTasks(params) {
      console.log('putAsyncTasks', params)
      this.asyncTaskRequest(params);
    },
    /**
     *  发送 异步任务请求 并且 处理 异步任务请求
     * */
    asyncTaskRequest(files) {
      let param = {
        files: files
      };
      exportApi
        .async(param)
        .then(res => {
          if (!this.tasks) {
            this.tasks = [];
          }
          if (res.code === 500) return this.$message.warning(res.msg);
          let files = res.data.files;
          this.tasks.push(...files);
          console.log("then tasks length---- %o", this.tasks.length);
          this.runRefreshAsyncTasksStatusInterval();
          // //发布put异步任务成功时间
          bus.$emit("putAsyncTasksSucess");
          //只要 put 任务我们就展示 下载框
          this.isHidden = true;
        })
        .catch(error => {
          console.log("error msg %o", error);
          this.$message.error({
            showClose: true,
            message: error.response.data.message,
            duration: 2000
          });
          bus.$emit("putAsyncTasksError", error.response.data.message);
        });
    },
    /**
     * 弹出提示框询问是否关闭
     */
    confirmAndCloseAll() {
      this.$confirm("确定清空全部任务吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.closeAll();
      });
    },
    /**
     * 当 notify  关闭时调用的回调
     */
    closeAll() {
      this.closeRefreshAsyncTasksStatusInterval();
      this.tasks = [];
    },
    /**
     * 是否隐藏
     **/
    shrink() {
      this.isHidden = !this.isHidden;
    },
    /**
     * 刷新异步任务状态
     */
    refreshAsyncTasksStatus() {
      let processingTasks = this.tasks
        .map((obj, index) => {
          let mapItemObj = obj;
          mapItemObj.index = index;
          return [obj.taskId, mapItemObj];
        })
        .filter(
          obj => $exportFileConstant.taskStatus.processing == obj[1].taskState
        );
      if (processingTasks && processingTasks.length > 0) {
        let processingTasksMap = new Map(processingTasks);
        let param = {
          taskIds: processingTasks.map(obj => obj[1].taskId)
        };
        exportApi
          .asyncStatus(param)
          .then(res => {
            if (res.data.files && res.data.files.length > 0) {
              res.data.files.forEach(obj => {
                if (obj) {
                  let task = processingTasksMap.get(obj.taskId);
                  if (task.taskState != obj.taskState) {
                    this.$set(this.tasks, task.index, obj);
                  }
                  if(obj.downloadURL) {
                    window.location.href = obj.downloadURL
                  }
                  
                }
              });
            }
          })
          .catch(error => {
            if (error.response.status == 401) {
              this.closeAll();
              return;
            }
            this.$message.error({
              showClose: true,
              message: error.message,
              duration: 2000
            });
          });
      }
    },
    /**
     * 开启 定时刷新异步任务状态  定时器  （间隔时间 1 秒）
     **/
    runRefreshAsyncTasksStatusInterval() {
      if (this.refreshAsyncTasksStatusInterval) {
        return;
      }
      this.refreshAsyncTasksStatusInterval = window.setInterval(() => {
        this.refreshAsyncTasksStatus();
      }, 1 * 1000);
    },
    /**
     * 关闭刷新异步任务状态
     */
    closeRefreshAsyncTasksStatusInterval() {
      window.clearInterval(this.refreshAsyncTasksStatusInterval);
      this.refreshAsyncTasksStatusInterval = undefined;
    }
  },
  created() {
    bus.$on("putAsyncTask", param => {
      this.putAsyncTask(param);
    });
    bus.$on("putAsyncTasks", param => {
      this.putAsyncTasks(param);
    });

    document.addEventListener("click", e => {
      let box = document.getElementById("exportFilePopover");
      let showExportBtn = document.getElementById("showExportBtn");
      if (
        box != null &&
        box != undefined &&
        showExportBtn != null &&
        showExportBtn != undefined
      ) {
        if (!box.contains(e.target) && !showExportBtn.contains(e.target)) {
          this.isHidden = true;
        }
      }
    });
  },
  mounted() {
    this.isEmbed = window.localStorage.getItem("isEmbed") == "true";
  },
  computed: {
    existTask() {
      return this.tasks && this.tasks.length > 0;
    },
    popoverShow: {
      get() {
        if (this.isEmbed) {
          return this.existTask;
        } else {
          return !this.isHidden;
        }
      },
      set(v) {
        // this.isHidden = !this.isHidden;
      }
    },
    popoverTaskHide() {
      if (this.isEmbed) {
        return this.taskDivHide;
      } else {
        return this.isHidden;
      }
    }
  }
};
</script>

<style scoped>
.df,
.flexdc {
  display: flex;
  overflow: hidden;
}

.list_round {
  width: 6px;
  height: 6px;
  position: relative;
  top: 4px;
  left: 7px;
  margin-right: 17px;
}

.success_color {
  color: #00bd16;
}

.load_fail_btn {
  background-color: #ffffff;
  line-height: 14px;
  font-size: 14px;
  display: inline-block;
  margin-left: 13px;
  padding: 5px 8px;
  color: #5b6be7;
  border-radius: 20px;
}

.download-notify .hiddenBtn {
  position: absolute;
  /*top: 22px;*/
  /*right: 40px;*/
  cursor: pointer;
  color: #909399;
  font-size: 16px;
  z-index: 100000000000000 !important;
}

.download-notify .hiddenBtn {
  position: absolute;
  top: 22px;
  right: 40px;
  cursor: pointer;
  color: #909399;
  font-size: 16px;
}

.download-notify {
  z-index: 100;
}

#tasksDiv {
  overflow-y: auto;
  height: 330px;
  overflow-x: hidden;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-button {
  display: none;
}

::-webkit-scrollbar-corner {
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #93c7f5;
  border-radius: 9px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar-track-piece {
  background: linear-gradient(90deg, #d8d9de, #e6e8ec);
  background: -webkit-linear-gradient(90deg, #d8d9de, #e6e8ec);
  border-radius: 9px;
}

/* nav style*/
.messages {
  margin-right: 20px;
  color: #fff;
}

.messages i {
  font-size: 20px;
  margin-right: 6px;
}

.hiddenBtn {
  position: absolute;
  top: 8px;
  right: 40px;
  cursor: pointer;
  color: #909399;
  font-size: 16px;
}

.el-notification__closeBtn {
  position: absolute;
  top: 8px;
  right: 15px;
  cursor: pointer;
  color: #909399;
  font-size: 16px;
}

.df {
  display: flex;
  overflow: hidden;
}

.el-message-box {
  z-index: 1000000000 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/component/exportFile/exportFile.vue